import { render } from "./SideMenu.vue?vue&type=template&id=04eaf4e4&scoped=true&ts=true"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"

import "./SideMenu.vue?vue&type=style&index=0&id=04eaf4e4&scoped=true&lang=css"

import exportComponent from "D:\\GitHub\\lexoh-parking-ionic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04eaf4e4"]])

export default __exports__